import { FC } from "react";
import { Transition } from "@headlessui/react";
import { useTranslation } from "next-i18next";
import { Area } from "@prisma/client";

import ActiveFilters from "./active-filters";
import FilterButtons from "./filter-buttons";

import { useFilters } from "@context/filter";

interface Props {
  areaData: Area[];
}

const FiltersFooter: FC<Props> = ({ areaData }) => {
  const { filters } = useFilters();
  const { t } = useTranslation("category", { keyPrefix: "filters" });

  const filtersText = [
    { value: filters.suppliersSet, name: t("supplier.label") },
    { value: filters.colorSet, name: t("colors.label") },
    { value: filters.materialSet, name: t("material.label") },
    { value: filters.stylesSet, name: t("style.label") },
    { value: filters.areasSet, name: t("area.label") },
    { value: filters.price, name: t("price.label"), isSet: filters.priceIsSet },
    {
      value: filters.lengthQuery,
      name: t("measures.length.label"),
      isSet: filters.lengthIsSet,
    },
    {
      value: filters.heightQuery,
      name: t("measures.height.label"),
      isSet: filters.heightIsSet,
    },
    {
      value: filters.widthQuery,
      name: t("measures.width.label"),
      isSet: filters.widthIsSet,
    },
  ]
    .reduce((text, { value, name, isSet }) => {
      let newText = text;

      if (value instanceof Set) {
        if (value.size) {
          newText += ` ${name} ${Array.from(value).join(", ")}.`;
        }
      } else {
        if (isSet) {
          newText += ` ${name} ${value.join("-")}${
            name.startsWith("Ma") ? " cm" : " €"
          }.`;
        }
      }

      return newText;
    }, "")
    .trim();

  return (
    <Transition
      show={filtersText.length > 0}
      enter="transition duration-200 origin-top ease-out"
      enterFrom="scale-50 opacity-50"
      enterTo="scale-100 opacity-100"
      leave="transition duration-200 origin-top ease-in"
      leaveFrom="scale-100 opacity-100"
      leaveTo="scale-0 opacity-0"
    >
      <FilterButtons />
      <ActiveFilters {...{ filtersText, areaData }} />
    </Transition>
  );
};

export default FiltersFooter;
